import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// services
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// types
import { UserOutcomeDetail } from '@app/outcomes/outcomes-api.model';

@Component({
  selector: 'dgx-certification-details',
  templateUrl: './certification-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CertificationDetails {
  @Input() public item: UserOutcomeDetail;

  public i18n = this.translateService.instant([
    'Cred_Certificate_Issuer',
    'Cred_Certificate_DateIssued',
    'dgUserOutcomeEditForm_IssuerUrl',
  ]);

  constructor(
    private translateService: TranslateService,
    private ngbModalService: NgbModal
  ) {}

  public get certificateHeader(): string {
    return this.translateService.instant('Cred_Certificate_Details', {
      certificate: this.item.contentType,
    });
  }

  public get certificateTitle(): string {
    return this.translateService.instant('Cred_Certificate_TitleOf', {
      certificate: this.item.contentType,
    });
  }

  public close(): void {
    this.ngbModalService.dismissAll();
  }
}
